import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const CircleAlert = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='CircleAlert' {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM13 6V14H11V6H13ZM13 16V18H11V16H13Z' fill='#000' />
  </StyledIcon>
);
